import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { BodyAsFormData } from "../../../services/utilities/util";
import FilterContext from "../../../routes/FilterContext";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import "jspdf-autotable";
import { connect } from "react-redux";
import Accordion from "react-bootstrap/Accordion";
import { Modal } from "react-bootstrap";
import Select, {
  components,
  MultiValueGenericProps,
  MultiValueProps,
  OnChangeValue,
  Props,
} from "react-select";
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}

class LeaseAnalysis extends React.Component {
  static contextType = FilterContext;

  state = {
    currentLease: {},
    filters: "",
    isOpen: false,
    leaseId: [],
    selectedLeaseId: [],
    apiData: [],
  };

  componentDidMount() {
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.state.filters = filters;
    apiMiddleware
      .post(
        "api/edge/office/get_custom_lease_analysis",
        BodyAsFormData(filters)
      )
      .then((res) => {
        this.setState({ currentLease: res.data });
      });

    apiMiddleware
      .post(`api/screener/get_data?q=Lease_Id&screener=edge_office`)
      .then((res) => {
        this.setState({ leaseId: res.data.suggestions });
      });
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters){
      this.setState({ filters: this.props.filters });

      apiMiddleware
        .post(
          "api/edge/office/get_custom_lease_analysis",
          BodyAsFormData(JSON.stringify(this.props.filters))
        )
        .then((res) => {
          this.setState({ currentLease: res.data });
        });
    }
  }

  addCompare() {
    this.setState({ isOpen: true });
  }

  getSelectedLease(e) {
    console.log(this.state.filters);
    this.setState({ apiData: this.state.filters });
    var leaseIdObj = {};
    this.setState({ selectedLeaseId: e }, () => {
      for (let i = 0; i < this.state.selectedLeaseId.length; i++) {
        leaseIdObj = {
          id: this.state.selectedLeaseId[i].id,
          label: this.state.selectedLeaseId[i].label,
          value: this.state.selectedLeaseId[i].value,
        };
        this.state.apiData.creid.push(leaseIdObj);
      }
    });
  }
  compareLeases = () => {
    for (let i = 0; i < this.state.currentLease.length; i++) {
      var ul = document.getElementById("compareUl");
      var li = document.createElement("li");
      li.appendChild(document.createTextNode("Comparable"));
      ul.appendChild(li);
    }
    this.closeModal();
    apiMiddleware
      .post(
        "api/edge/office/get_custom_lease_analysis",
        BodyAsFormData(JSON.stringify(this.state.apiData))
      )
      .then((res) => {
        this.setState({ currentLease: res.data }, () => {
          console.log(this.state.currentLease);
        });
      });
  };
  closeModal = () => this.setState({ isOpen: false });

  render() {
    return (
      <div className="container-fluid unitsRents assets leaseAnalysis">
        <div className="row">
          <div className="col-lg-12 mt-3 mb-4 p-0">
            <ul id="compareUl">
              <li
                onClick={(e) => {
                  this.addCompare();
                }}
              >
                <FontAwesomeIcon icon={faPlus} /> Add Comparable
              </li>
              <li>This Lease</li>
            </ul>
          </div>
          <Accordion defaultActiveKey="0" flush>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Area Details</Accordion.Header>
              <Accordion.Body>
                <table className="table table-striped">
                  <tbody>
                    <tr>
                      <td className="leaseAnalysisTdOne">Chargeable area</td>
                      {this.state.currentLease.length > 0 &&
                        this.state.currentLease.map((row, i) => (
                          <td>{row.chargeable_area}</td>
                        ))}
                    </tr>
                    <tr>
                      <td className="leaseAnalysisTdSecond">Carpet area</td>
                      {this.state.currentLease.length > 0 &&
                        this.state.currentLease.map((row, i) => (
                          <td>{row.carpetarea}</td>
                        ))}
                    </tr>
                  </tbody>
                </table>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>Rental Details</Accordion.Header>
              <Accordion.Body>
                <table className="table table-striped">
                  <tbody>
                    <tr>
                      <td className="leaseAnalysisTdOne">Starting Rent</td>
                      {this.state.currentLease.length > 0 &&
                        this.state.currentLease.map((row, i) => (
                          <td>{row.starting_rent}</td>
                        ))}
                    </tr>
                    <tr>
                      <td className="leaseAnalysisTdSecond">Current Rent</td>
                      {this.state.currentLease.length > 0 &&
                        this.state.currentLease.map((row, i) => (
                          <td>{row.current_rent}</td>
                        ))}
                    </tr>
                    <tr>
                      <td className="leaseAnalysisTdSecond">Effective Rent</td>
                      {this.state.currentLease.length > 0 &&
                        this.state.currentLease.map((row, i) => (
                          <td>{row.effective_rent}</td>
                        ))}
                    </tr>
                  </tbody>
                </table>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>Key Dates</Accordion.Header>
              <Accordion.Body>
                <table className="table table-striped">
                  <tbody>
                    <tr>
                      <td className="leaseAnalysisTdOne">Lease Term</td>
                      {this.state.currentLease.length > 0 &&
                        this.state.currentLease.map((row, i) => (
                          <td>{row.leaseterm}</td>
                        ))}
                    </tr>
                    <tr>
                      <td className="leaseAnalysisTdSecond">Lock-in Period</td>
                      {this.state.currentLease.length > 0 &&
                        this.state.currentLease.map((row, i) => (
                          <td>{row.lockinperiod}</td>
                        ))}
                    </tr>
                    <tr>
                      <td className="leaseAnalysisTdSecond">
                        Rent Free Period
                      </td>
                      {this.state.currentLease.length > 0 &&
                        this.state.currentLease.map((row, i) => (
                          <td>{row.rentfreeperiod_months}</td>
                        ))}
                    </tr>
                  </tbody>
                </table>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              <Accordion.Header>Other Details</Accordion.Header>
              <Accordion.Body>
                <table className="table table-striped">
                  <tbody>
                    <tr>
                      <td className="leaseAnalysisTdOne">Escalations</td>
                      {this.state.currentLease.length > 0 &&
                        this.state.currentLease.map((row, i) => (
                          <td>{row.rent_escalation}</td>
                        ))}
                    </tr>
                    <tr>
                      <td className="leaseAnalysisTdSecond">Free Car Park</td>
                      {this.state.currentLease.length > 0 &&
                        this.state.currentLease.map((row, i) => (
                          <td>{row.freecars}</td>
                        ))}
                    </tr>
                    <tr>
                      <td className="leaseAnalysisTdSecond">Paid Car Park</td>
                      {this.state.currentLease.length > 0 &&
                        this.state.currentLease.map((row, i) => (
                          <td>{row.paidcars}</td>
                        ))}
                    </tr>
                    <tr>
                      <td className="leaseAnalysisTdSecond">
                        Security Deposit
                      </td>
                      {this.state.currentLease.length > 0 &&
                        this.state.currentLease.map((row, i) => (
                          <td>{row.security_deposit}</td>
                        ))}
                    </tr>
                    <tr>
                      <td className="leaseAnalysisTdSecond">CAM Charges</td>
                      {this.state.currentLease.length > 0 &&
                        this.state.currentLease.map((row, i) => (
                          <td>{row.cam_charges}</td>
                        ))}
                    </tr>
                  </tbody>
                </table>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
        <div className="row">
          <div className="col-lg-12 ">
            <Modal
              show={this.state.isOpen}
              onHide={this.closeModal}
              className="compareModal"
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  <FontAwesomeIcon icon={faPlus} /> Add Comparable
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12 mb-3">
                      <Select
                        options={this.state.leaseId}
                        onChange={(e) => {
                          this.getSelectedLease(e);
                        }}
                        isMulti
                      />
                    </div>
                    <div className="col-lg-12 text-center">
                      <button
                        type="submit"
                        className="btnClose"
                        onClick={(e) => {
                          this.compareLeases();
                        }}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(LeaseAnalysis);
